import Dexie from 'dexie';

const PREFERENCE_KEY = 'cardGenerationNotifications';
const DEFAULT_ENABLED = true;

interface NotificationPreferenceRecord {
    key: string;
    enabled: boolean;
    updatedAt: number;
}

class AiGenerationSettingsDb extends Dexie {
    notificationPreferences!: Dexie.Table<NotificationPreferenceRecord, string>;

    constructor() {
        super('aiGenerationSettingsDb');
        this.version(1).stores({
            notificationPreferences: 'key',
        });
    }
}

const db = new AiGenerationSettingsDb();

export async function loadCardGenerationNotificationsEnabled(): Promise<boolean> {
    try {
        const record = await db.notificationPreferences.get(PREFERENCE_KEY);
        if (record === undefined) {
            return DEFAULT_ENABLED;
        }

        return record.enabled;
    } catch (error) {
        console.error('Failed to load card generation notification preference:', error);
        return DEFAULT_ENABLED;
    }
}

export async function saveCardGenerationNotificationsEnabled(enabled: boolean): Promise<void> {
    try {
        await db.notificationPreferences.put({
            key: PREFERENCE_KEY,
            enabled,
            updatedAt: Date.now(),
        });
    } catch (error) {
        console.error('Failed to save card generation notification preference:', error);
    }
}
